/**
 * Guard for rendering a stored URL as an `<a href>` (issue #2000 review).
 *
 * The backend URL check (`safeUrlSchema`, Zod `.url()`) accepts any scheme,
 * including `javascript:` and `data:`, and admin bulk and import paths write
 * attributes without it. A stored value is therefore untrusted at render time:
 * only absolute `http:` / `https:` URLs become links.
 */

const LINKABLE_PROTOCOLS: ReadonlySet<string> = new Set(['http:', 'https:']);

/**
 * `url` when it parses as an absolute `http:` or `https:` URL, otherwise
 * `null`. Relative or malformed values fail `new URL()` without a base, so
 * they are never resolved against the page origin.
 */
export function safeExternalHref(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }
  try {
    return LINKABLE_PROTOCOLS.has(new URL(url).protocol) ? url : null;
  } catch {
    return null;
  }
}
